import { Sparkles, ArrowRight, CheckCircle, Send } from 'lucide-react';

export const API_URL = process.env.REACT_APP_BACKEND_URL;

export const fetchWithAuth = async (url, options = {}) => {
  const token = localStorage.getItem('backoffice_token');
  const res = await fetch(url, {
    ...options,
    headers: { ...options.headers, Authorization: `Bearer ${token}` },
  });
  if (res.status === 401) {
    localStorage.removeItem('backoffice_token');
    window.location.href = '/admin/login';
    throw new Error('Unauthorized');
  }
  return res.json();
};

export const PRIORITY_STYLES = {
  high: 'bg-red-50 text-red-700 border-red-200',
  medium: 'bg-amber-50 text-amber-700 border-amber-200',
  standard: 'bg-blue-50 text-blue-700 border-blue-200',
};

export const STATUS_STYLES = {
  auto_qualified: { label: 'Auto-Qualified', cls: 'bg-purple-50 text-purple-700', icon: Sparkles },
  ready_for_outreach: { label: 'Ready for Outreach', cls: 'bg-green-50 text-green-700', icon: ArrowRight },
  contacted: { label: 'Contacted', cls: 'bg-blue-50 text-blue-700', icon: CheckCircle },
  added_to_campaign: { label: 'In Campaign', cls: 'bg-indigo-50 text-indigo-700', icon: Send },
};

export const CANDIDATE_STAGES = [
  { value: 'sourced', label: 'Sourced', cls: 'bg-gray-100 text-gray-600' },
  { value: 'reviewed', label: 'Reviewed', cls: 'bg-blue-100 text-blue-700' },
  { value: 'contacted', label: 'Contacted', cls: 'bg-indigo-100 text-indigo-700' },
  { value: 'interested', label: 'Interested', cls: 'bg-purple-100 text-purple-700' },
  { value: 'submitted', label: 'Submitted', cls: 'bg-amber-100 text-amber-700' },
  { value: 'placed', label: 'Placed', cls: 'bg-emerald-100 text-emerald-700' },
];

export const STRENGTH_LABELS = {
  strong: 'Strong',
  medium: 'Medium',
  weak: 'Weak',
  weak_needs_refinement: 'Needs Refinement',
  empty: 'No Candidates',
};

export const STRENGTH_DOT = {
  strong: 'bg-emerald-500',
  medium: 'bg-amber-400',
  weak: 'bg-red-400',
  weak_needs_refinement: 'bg-red-500',
  empty: 'bg-gray-300',
};

export const STRENGTH_LABEL_MAP = {
  strong: 'Strong Pipeline',
  medium: 'Medium Pipeline',
  weak: 'Weak Pipeline',
  weak_needs_refinement: 'Needs Refinement',
  empty: 'No Candidates',
};

export const VERTICAL_COLORS = {
  accounting_finance: 'bg-blue-50 text-blue-700 border-blue-200',
  healthcare: 'bg-red-50 text-red-700 border-red-200',
  logistics_supply_chain: 'bg-amber-50 text-amber-700 border-amber-200',
  hr_compliance: 'bg-green-50 text-green-700 border-green-200',
};
